document.querySelectorAll('select').forEach(function(el) {
    if ( el.value == '' ) {
        el.classList.add('_empty');
    }
    el.addEventListener('change', function() {
        if ( el.value == '' ) {
            el.classList.add('_empty');
        } else {
            el.classList.remove('_empty');
        }
    });
});